import * as React from 'react';
import { connect, Dispatch } from 'react-redux';

import { AppState } from 'src';

import { toggleModal } from '@common/components/common.actions';
import { AccountViewModel } from '@models/Account';
import { CreditCardPaymentViewModel } from '@models/Payment';

import { CreditCard } from './_components/credit-card.container';
import { deleteAccount, getAccount, resetCreditCardList } from './credit-card.actions';
import { CreditCardListComponent, CreditCardListComponentProperties } from './credit-card-list.component';

export interface CreditCardListProperties {
  readonly accountType: number;
  readonly accountId?: number;
  readonly withHostedCheckout?: boolean;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: CreditCardListProperties
): Partial<CreditCardListComponentProperties> {
  return {
    accountId: ownProps.accountId,
    accountType: ownProps.accountType,
    creditCard: state.creditCards.creditCard,
    withHostedCheckout: ownProps.withHostedCheckout
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: CreditCardListProperties
): Partial<CreditCardListComponentProperties> {
  return {
    getAccount: (accountId: number) => {
      dispatch(getAccount(accountId));
    },
    openCreditCardModal: (
      accountId: number,
      accountType: number,
      creditCard?: AccountViewModel,
      hostedCheckoutButton?: HTMLButtonElement
    ) => {
      if (ownProps.withHostedCheckout && hostedCheckoutButton) {
        hostedCheckoutButton.click();
        return;
      }

      const title = creditCard ? 'Edit Credit Card Info' : 'Add New Credit Card';
      const saveLabel = creditCard ? 'Update Card' : 'Create Card';

      dispatch(
        toggleModal({
          title: title,
          component: CreditCard,
          childProps: {
            creditCard: creditCard
          },
          closeLabel: 'Cancel',
          saveLabel: saveLabel,
          saveCallback: (creditCardToUpdate: CreditCardPaymentViewModel) => {
            dispatch(toggleModal());
          },
          isSmall: true
        })
      );
    },
    openDeleteModal: (creditCard: AccountViewModel) => {
      dispatch(
        toggleModal({
          title: 'Delete Credit Card',
          component: () => <h3>Are you sure you want to delete the Credit Card?</h3>,
          closeLabel: 'Cancel',
          saveLabel: 'Delete Card',
          saveCallback: () => {
            dispatch(deleteAccount(creditCard.accountId));
            dispatch(toggleModal());
          },
          isSmall: true
        })
      );
    },
    resetCreditCardList: () => {
      dispatch(resetCreditCardList());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CreditCardList = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreditCardListComponent);



// WEBPACK FOOTER //
// ./src/common/components/credit-cards/credit-card-list.container.tsx